import axios from "axios";
import { api } from "@/api";
const configHeaders = {
  headers: {
    Authorization: 'mosokna01092021',
  }
};


export default {
  calculateOptionsValues(_, body) {
    return new Promise((resolve, reject) => {
      api.methods.calculate.options.values.post(body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  getSumCalculate ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/calculate`, params.body).then(res => {
        resolve(res.data);
        commit('updateSumCalculate', res.data);
        if (res.data.currency_symbol) {
          commit('updateCurrency', res.data.currency_symbol);
        }
      }, error => {
        reject(error)
      })
    })
  },

  loadBasketServices ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/services`).then(res => {
        resolve(res.data);
        commit('updateBasketServices', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  loadBasketOrder ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${params.id}/detail-info`).then(res => {
        resolve(res.data);
        commit('updateBasketAccountOrder', res.data);
        commit('updateCurrency', res.data.currency.symbol);
        commit('updateBasketOrder', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setBasketOrder ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${params.id}/detail-info`).then(res => {
        resolve(res.data);
        commit('updateBasketOrder', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  saveBasketOrder ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${params.id}/update`, params.body).then(res => {
      }, error => {
        reject(error)
      })
    })
  },


  loadBasketDiscount ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/calc-discounts`, params.body).then(res => {
        resolve(res.data);
        commit('updateBasketDiscountPercent', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  sendPlaceOrder ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders`, params.body).then(res => {
        commit('common/updateCurrentPopup', {
          state: true,
          name: 'PopupThanks',
        }, {root: true});
        resolve(res.data)
      }, error => {
        commit('common/updateCurrentPopup', {
          state: true,
          name: 'PopupError',
        }, {root: true});
        reject(error)
      })
    })
  },

  changeBasketItemComment ({ commit }, {index, value}) {
    commit('updateBasketItemComment', {
      index,
      value
    });
  }
}
